import { gql } from "generated-graphql";

/**
 * Resolves the selected stream's `facilityId` (needed to scope the modal's
 * facility context) from the `wasteStreamId` in the URL. Apollo serves this
 * from the cache the grid query already populated on a normal row click; it
 * only hits the network on deep links / refreshes where the grid hasn't run.
 */
export const GET_TENANT_STREAM_META_QUERY = gql(`
  query GetTenantStreamMeta($id: ID!) {
    wasteStream(id: $id) {
      id
      facilityId
    }
  }
`);

export const TENANT_WASTE_STREAMS_QUERY = gql(`
  query TenantWasteStreams(
    $tenantId: ID!,
    $search: String
    $page: Int
    $pageSize: Int
    $sort: [SortModel!]
    $startDate: Date
    $endDate: Date
    $view: FacilityWasteView
    $tags: [String!]
  ) {
    tenant(id: $tenantId) {
      id
      wasteStreams(
        search: $search
        page: $page
        pageSize: $pageSize
        sort: $sort
        startDate: $startDate
        endDate: $endDate
        view: $view
        tags: $tags
      ) {
        items {
          id
          name
          facilityId
          facility {
            id
            name
          }
          classification
          federalWasteCodes
          stateWasteCodes
          eManifestProfileNumber
          vendorProfileNumber
          formCode
          sourceCode
          managementMethodCodes
          vendorAmount
          eManifestAmount
          effectiveAmount
          vendorAmountAllTime
          eManifestAmountAllTime
          lastShipmentDateAllTime
          mergeCount
          comment
          willNotReport
          isProvisional
        }
        count
      }
    }
  }
`);
